import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';
import { androidContentOffset } from 'Theme/Theme';

const defaultStyles = {
    container: {
        paddingHorizontal: Theme.primaryMargin,
        paddingVertical: Theme.primaryMargin,
        marginTop: Device.isTabletOrWeb ? 13 : 25
    },
    content: {
        marginTop: 10,
        ...androidContentOffset
    },
    sectionTitle: {
        ...fontStyles.settingsHeading,
        marginTop: 50,
        paddingBottom: 5
    },
    note: {
        color: Theme.secondaryTextColor,
        marginTop: 10,
        lineHeight: 22
    }
};

export default StyleSheet.create(defaultStyles);
